"use strict";

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/app/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var universe_log_1 = require("universe-log");

var Log =
/*#__PURE__*/
function (_universe_log_1$Abstr) {
  _inherits(Log, _universe_log_1$Abstr);

  function Log() {
    _classCallCheck(this, Log);

    return _possibleConstructorReturn(this, _getPrototypeOf(Log).call(this, {
      levelEnvs: ["STEEM_CONTENT_RENDERER_LOG_LEVEL", "ENGRAVE_LOG_LEVEL"],
      metadata: {
        library: "steem-content-renderer"
      }
    }));
  }

  _createClass(Log, [{
    key: "initialize",
    value: function initialize() {
      _get(_getPrototypeOf(Log.prototype), "init", this).call(this);
    }
  }, {
    key: "init",
    value: function init() {
      throw new Error("Instead of #init() please call #initialize() which indirectly overrides init");
    }
  }], [{
    key: "log",
    value: function log() {
      return Log.INSTANCE;
    }
  }]);

  return Log;
}(universe_log_1.AbstractUniverseLog);

Log.INSTANCE = new Log();
exports.Log = Log;